import React, { FC } from 'react';
import styled from 'styled-components';

const WrapperWithRightDrawer:FC = ({ children }) => {
    return (
      <SlideArea>
        {children}
      </SlideArea>
    );
};

export default WrapperWithRightDrawer;

const SlideArea = styled.div`
  display: flex;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 84vh;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  @media only screen and (max-width: 840px) {
    height: 81vh;
  }
`;
